import { Col, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { INameField } from "./INameField";

import { sizes } from "../../../Assets/Enums";

const NameField = ({ name, translations, index = 0, errors, handleChangeData, size = "m", disabled = false }: INameField) => (
	<Col xs={24} md={sizes[size]} lg={sizes[size]} >
		<label className="required">
			{translations.nombreFirmante}
			<Tooltip placement="top" title={<span>{translations.signerNameTooltip}</span>}>
				{" "} <InfoCircleOutlined />
			</Tooltip>
		</label>
		<Input
			className="input-field"
			name="name"
			value={name}
			onChange={handleChangeData(index)}
			placeholder={translations.nombreFirmante}
			disabled={disabled}
			status={
				Array.isArray(errors)
					? (errors[index]?.name || errors[index]?.invalidNameFormat ? "error" : "")
					: (errors.name || errors.invalidNameFormat ? "error" : "")
			}
		/>
		<span className={`error ${
			Array.isArray(errors)
				? errors[index]?.name ? 'show' : null
				: errors.name ? 'show' : null
		}`}>
			{translations.completeCampo}
		</span>
		<span className={`error ${
			Array.isArray(errors)
				? errors[index]?.invalidNameFormat ? 'show' : null
				: errors.invalidNameFormat ? 'show' : null
		}`}>
			{translations.invalidFormat}
		</span>
	</Col>
);

export default NameField;